import React, {useEffect, useState, lazy, Suspense} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Button, Card, Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from "@material-ui/core";
import {Col, Row} from "reactstrap";
import {bbFindEntityWithinPortfolioOrSelf, bbFormattedDateString, isCurrentUserMemberOf} from "../../../util/bbHelpers";
import {fetchIdentityDetails, fetchTargetDetails} from "../../../actions";
import BBIconHostInspectorMagnifyingGlassDatabase
    from "../../../assets/bbCustomIcons/BBIconHostInspectorMagnifyingGlassDatabase";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import CloseIcon from "@material-ui/icons/Close";
import Skeleton from "react-loading-skeleton";
import BRSocialTestsTable from "./BRSocialTestsTable";
import IdentityScopeToggle from "./IdentityScopeToggle";
import BBIconInspectIdentity from "../../../assets/bbCustomIcons/BBIconInspectIdentity";

const BRSocialIdentitiesDetailsModal = ({identityId = null, sentToAddress = null,})=>{

    const dispatch = useDispatch();

    const [open, setOpen] = useState(false);

    const {customers, customerInView} = useSelector(({customer}) => customer);

    const {portfolios, entityInView} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    const isAdmin = isCurrentUserMemberOf(authUser, "admin");

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const lastCycle = myEntity ? myEntity.last_cycle : null

    const identities = myEntity
        && myEntity.cycles
        && myEntity.cycles[lastCycle.cycle]
        && myEntity.cycles[lastCycle.cycle].social
        && myEntity.cycles[lastCycle.cycle].social.identities;

    const identity = identities && identityId && identities[identityId];

    const identityTags = identity && identity.tags && Object.values(identity.tags).filter((tag)=> tag.is_active)

    const isOutOfScope = identityTags && Array.isArray(identityTags) && identityTags.length > 0;

    const outOfScopeTag = isOutOfScope
        ? identityTags
            .sort((a,b)=> b.added_datetime - a.added_datetime)
            .slice(0, 1)
            .shift()
        : null;

    const [identityHasUpdatedDetails, setIdentityHasUpdatedDetails] = useState(!!(identity
        && (identity.tests || identity.test_detail || identity.details || identity.valid)));


    useEffect(()=>{
        if(open){
            // console.log("identityId", identityId, "this is identity", identity)
            if(identity && !identityHasUpdatedDetails){
                // console.log("useEffect called", identityHasUpdatedDetails,);
                dispatch(fetchIdentityDetails(
                    {
                        identityId: identityId,
                        entityId: myEntity.id,
                        cycleId: lastCycle.cycle,
                        customerId: customerIdToUse,
                    }
                ));
                setIdentityHasUpdatedDetails(!!(identity
                    && (identity.tests || identity.test_detail ||identity.details || identity.valid)));
            }
        }

        setIdentityHasUpdatedDetails(!!(identity
            && (identity.tests || identity.test_detail ||identity.details || identity.valid)));

    }, [open, identity, identityHasUpdatedDetails, ])

    // console.log("This is identity", identity);

    return(
        <div>
            <Tooltip title={"Inspect Identity"}>
                {sentToAddress
                    ? <p onClick={()=> setOpen(true)}
                         className={"m-0 p-0 btn-link"}
                    ><Button variant="outlined" size="small" style={{textTransform: 'lowercase'}} >{sentToAddress}</Button></p>
                    :<IconButton
                        onClick={()=> setOpen(true)}
                        >
                    <BBIconInspectIdentity/>
                </IconButton>}
            </Tooltip>

            <Dialog open={open}
                    fullScreen={false}
                    fullWidth={true}
                    maxWidth={"lg"}
                    className={"m-1 p-1 animated fadeIn animation-duration-6"}
                    aria-labelledby="form-dialog-title">

                <DialogTitle id="customized-dialog-title" >
                    <Row>
                        <Col lg={11}/>
                        <Col lg={1} className={"text-right align-self-center d-print-none"}>
                            <IconButton
                                onClick={()=>setOpen(false)}
                                className={"close"}>
                                <CloseIcon/>
                            </IconButton>
                        </Col>
                    </Row>
                </DialogTitle>
                <DialogContent>
                    {identity && identityHasUpdatedDetails
                        ?
                        <div>
                            <Card style={{width: "100%"}}>
                                <div className={"card-header"}>
                                    <Row className={"card-title text-center"}>
                                        <Col lg={11}>
                                            <h1>{identity.first ? identity.first : "--"} {identity.last? identity.last : "--"}</h1>
                                        </Col>
                                        <Col className={"close"}>
                                            <IdentityScopeToggle identityId={identityId} className={"m-0 p-0 align-self-center d-inline"}/>
                                        </Col>
                                    </Row>
                                    <Row className={"text-center"}>
                                        <Col className={"border-right border-gray"}>
                                            {identity.email ? identity.email : "--"}
                                        </Col>
                                        <Col className={"border-right border-gray"}>
                                            {identity.position ? identity.position : "Position Unknown"}
                                        </Col>
                                        <Col>
                                            {bbFormattedDateString(identity.created_datetime, "shortFullMonth")}
                                        </Col>
                                    </Row>
                                </div>

                                <Row className={"text-center m-1 p-1"}>
                                    <Col>
                                        Spearphishing Emails Sent: {identity.tests ? identity.tests : "--"}
                                    </Col>
                                    <Col>
                                        Last Test: {identity.last_tested_datetime ? bbFormattedDateString(identity.last_tested_datetime, "shortFullMonth") : "--"}
                                    </Col>
                                </Row>


                                {/*{identity.details && Object.keys(identity.details).length > 0 &&*/}
                                {/*<div>*/}
                                {/*    <Row>*/}
                                {/*        <Col>*/}
                                {/*            <h3>*/}
                                {/*                Details:*/}
                                {/*            </h3>*/}
                                {/*        </Col>*/}
                                {/*    </Row>*/}
                                {/*    <Row>*/}
                                {/*        <Col>*/}

                                {/*        </Col>*/}
                                {/*    </Row>*/}
                                {/*</div>*/}
                                {/*}*/}



                                {identity.test_detail && Object.keys(identity.test_detail).length > 0 &&
                                <BRSocialTestsTable modalDisplay={true} modalTests={identity.test_detail}/>}



                            </Card>
                        </div>
                        :
                        <div>
                            <div style={{width:"100%"}}>
                                Loading Identity Details...
                                <Row>
                                    <Col>
                                        <h2>
                                            <Skeleton count={6}/>
                                        </h2>
                                    </Col>
                                </Row>
                            </div>
                        </div>

                    }

                </DialogContent>

            </Dialog>

        </div>
    )
}

export default BRSocialIdentitiesDetailsModal;